import { render } from "./shopCard.vue?vue&type=template&id=2ff5d993&scoped=true"
import script from "./shopCard.vue?vue&type=script&lang=js"
export * from "./shopCard.vue?vue&type=script&lang=js"

import "./shopCard.vue?vue&type=style&index=0&id=2ff5d993&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff5d993"]])

export default __exports__